module.exports = __webpack_public_path__ + "f0b5eb2f309ce3b61d3cb056b4d7fe15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/otherPay_active.png
// module id = 295
// module chunks = 0